import React from 'react';
import Input from './Input';
import Radio from './Radio';

const Field = ({ data, index, state, updateState}) => {
  switch(data.type) {
    case 'input':
      return <Input data={data} index={index} state={state[index].v} updateState={(e) => updateState(e.target.value, index)} />
    case 'radio':
      return <Radio data={data} index={index} state={state[index].v} updateState={(e) => updateState(e.target.value, index)} />
    default:
      return <></>
      break;
  }
};

export default Field;